import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ThemeProvider from "./theme";
import { ThemeContextProvider } from "./context/ThemeContext";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { ToastContainer } from "react-toastify";
import { initializeFirebaseAppCheck } from "./firebase";
import "react-toastify/dist/ReactToastify.css";

// Initialize Firebase App Check (enterprise) if a site key is provided
try {
  initializeFirebaseAppCheck();
} catch (_e) {
  // App Check initialization is optional; proceed without it if unavailable
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeContextProvider>
      <ThemeProvider>
        <LocalizationProvider dateAdapter={AdapterLuxon}>
          <App />
          <ToastContainer />
        </LocalizationProvider>
      </ThemeProvider>
    </ThemeContextProvider>
  </React.StrictMode>,
);

reportWebVitals();
